/* LicensedTime product page: gallery, band color swatches, quantity, add to cart (Horizon cart events). */
const root = document.querySelector('[data-lt-pdp]');

if (root) {
  const $ = (s, r) => (r || root).querySelector(s);
  const $$ = (s, r) => Array.from((r || root).querySelectorAll(s));
  const dataEl = $('[data-lt-pdp-json]');
  const data = dataEl ? JSON.parse(dataEl.textContent) : null;

  const form = $('[data-lt-form]');
  const idInput = $('[data-lt-variant-id]');
  const priceEls = $$('[data-lt-price],[data-lt-sticky-price]');
  const atc = $('[data-lt-atc]');
  const atcText = $('[data-lt-atc-text]');
  const stickyAtc = $('[data-lt-sticky-atc]');
  const colorName = $('[data-lt-color-name]');
  const stickyColor = $('[data-lt-sticky-color]');
  const skuEl = $('[data-lt-sku]');
  const errorEl = $('[data-lt-error]');
  const statusEl = $('[data-lt-status]');
  const swatches = $$('.lt-swatch');
  const qtyInput = $('[data-lt-qty-input]');

  /* ---------- gallery ---------- */
  const gal = $('[data-lt-gal]');
  const track = $('[data-lt-track]', gal);
  const slides = $$('.lt-gal__slide', gal);
  const thumbsEl = $('[data-lt-thumbs]', gal);
  const counter = $('[data-lt-counter]', gal);
  const LABELS = { product: 'Product view', life: 'Lifestyle view', gift: 'Gift box view', logo: 'Logo detail view', use: 'In use view', box: 'In the box view', scale: 'Size comparison view' };
  const mobile = window.matchMedia('(max-width: 1023px)');
  let active = 0;

  const mediaFor = (kind, variantMedia) => {
    if (!data) return null;
    if (kind === 'product') return data.media[variantMedia] || data.media[data.primary] || null;
    // Pages with named gallery slots (the Tech page: logo, use, box) list them in data.slots; the watch page uses life and gift.
    if (data.slots && data.slots[kind]) return data.media[data.slots[kind]] || null;
    return data.media[kind === 'life' ? data.life : data.gift] || null;
  };

  // One rail thumbnail per distinct color image (first variant that uses it); the main slide always shows the selected color.
  const bandThumbs = () => {
    const seen = new Set();
    const out = [];
    if (!data || !data.hasColor) return out;
    data.variants.forEach((v) => {
      if (!v.media || seen.has(String(v.media)) || !data.media[v.media]) return;
      seen.add(String(v.media));
      out.push(v);
    });
    return out.length > 1 ? out : [];
  };

  const addThumb = (i, kind, m, label, variant) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'lt-gal__thumb';
    b.setAttribute('role', 'tab');
    b.setAttribute('aria-label', label || LABELS[kind] || 'View');
    b.dataset.index = String(i);
    if (variant) b.dataset.variant = String(variant.id);
    b.innerHTML = m ? `<img src="${m.thumb}" alt="" width="88" height="88" loading="lazy">` : '';
    thumbsEl.appendChild(b);
  };

  const syncThumbs = () => {
    const cur = current();
    $$('.lt-gal__thumb', gal).forEach((b) => {
      const onSlide = Number(b.dataset.index) === active;
      const onBand = !b.dataset.variant || String(data.variants.find((v) => String(v.id) === b.dataset.variant).media) === String(cur.media || data.primary);
      b.setAttribute('aria-selected', String(onSlide && onBand));
    });
  };

  const buildThumbs = (variantMedia) => {
    thumbsEl.innerHTML = '';
    const bands = bandThumbs();
    slides.forEach((sl, i) => {
      const kind = sl.dataset.kind;
      if (kind === 'product' && bands.length) {
        const ci = data.colorIndex;
        bands.forEach((v) => addThumb(i, kind, data.media[v.media], `${v.options[ci]}${data.colorNoun === undefined ? ' band' : data.colorNoun} view`, v));
      } else {
        addThumb(i, kind, mediaFor(kind, variantMedia));
      }
    });
    syncThumbs();
  };

  const updateCounter = () => {
    if (counter) counter.textContent = slides.length > 1 ? `${active + 1} / ${slides.length}` : '';
  };

  const show = (i, scroll) => {
    active = Math.max(0, Math.min(slides.length - 1, i));
    slides.forEach((s, n) => s.classList.toggle('is-active', n === active));
    syncThumbs();
    updateCounter();
    if (scroll && mobile.matches) track.scrollTo({ left: slides[active].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };

  thumbsEl.addEventListener('click', (e) => {
    const b = e.target.closest('.lt-gal__thumb');
    if (!b) return;
    if (b.dataset.variant) {
      const v = data.variants.find((x) => String(x.id) === b.dataset.variant);
      const opts = current().options.slice();
      opts[data.colorIndex] = v.options[data.colorIndex];
      applyVariant(byOptions(opts) || v, true);
      return;
    }
    show(Number(b.dataset.index), true);
  });
  thumbsEl.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    e.preventDefault();
    const list = $$('.lt-gal__thumb', gal);
    const at = Math.max(0, list.findIndex((b) => b.getAttribute('aria-selected') === 'true'));
    const t = list[Math.max(0, Math.min(list.length - 1, at + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1)))];
    if (t) {
      t.click();
      t.focus();
    }
  });
  let scrollTimer;
  track.addEventListener(
    'scroll',
    () => {
      if (!mobile.matches) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const w = track.clientWidth || 1;
        const i = Math.round(track.scrollLeft / w);
        if (i !== active) {
          active = i;
          syncThumbs();
          updateCounter();
        }
      }, 60);
    },
    { passive: true }
  );

  /* ---------- variants ---------- */
  const current = () => data.variants.find((v) => String(v.id) === String(idInput.value)) || data.variants[0];
  const byOptions = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));

  const setImage = (img, m) => {
    if (!img || !m) return;
    const set = data.sets[Object.keys(data.media).find((k) => data.media[k] === m)] || [];
    img.src = m.src;
    img.alt = m.alt || '';
    if (set.length) img.srcset = set.map((u, i) => `${u} ${[600, 900, 1200, 1600, 2000][i]}w`).join(', ');
  };

  const applyVariant = (v, fromUser) => {
    idInput.value = v.id;
    priceEls.forEach((el) => (el.textContent = v.price));
    const label = v.available ? `Add to cart · ${v.price}` : 'Sold out';
    if (atcText) atcText.textContent = label;
    [atc, stickyAtc].forEach((b) => b && (b.disabled = !v.available));
    if (stickyAtc) stickyAtc.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (skuEl) skuEl.textContent = v.sku || '';
    if (data.hasColor) {
      const name = v.options[data.colorIndex];
      if (colorName) colorName.textContent = name;
      if (stickyColor) stickyColor.textContent = name;
      swatches.forEach((s) => s.setAttribute('aria-checked', String(s.dataset.value === name)));
      const cap = $('[data-role="caption"]', gal);
      if (cap) cap.textContent = `${name}${data.colorNoun === undefined ? ' band' : data.colorNoun}`;
    }
    const m = data.media[v.media] || data.media[data.primary];
    if (m) {
      setImage($('[data-role="main-img"]', gal), m);
      if (!bandThumbs().length) {
        const first = $('.lt-gal__thumb img', gal);
        if (first) first.src = m.thumb;
      }
      const st = $('[data-role="sticky-img"]');
      if (st) st.src = m.thumb;
    }
    if (fromUser) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      show(0, true);
    }
  };

  swatches.forEach((sw) =>
    sw.addEventListener('click', () => {
      const opts = current().options.slice();
      opts[data.colorIndex] = sw.dataset.value;
      const v = byOptions(opts) || data.variants.find((x) => x.options[data.colorIndex] === sw.dataset.value);
      if (v) applyVariant(v, true);
    })
  );
  const group = $('.lt-swatches__row');
  if (group) {
    group.addEventListener('keydown', (e) => {
      const keys = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'];
      if (!keys.includes(e.key)) return;
      e.preventDefault();
      const i = swatches.findIndex((s) => s.getAttribute('aria-checked') === 'true');
      const n = (i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + swatches.length) % swatches.length;
      swatches[n].focus();
      swatches[n].click();
    });
    // roving tabindex: only the checked swatch is in the tab order
    const sync = () => swatches.forEach((s) => s.setAttribute('tabindex', s.getAttribute('aria-checked') === 'true' ? '0' : '-1'));
    sync();
    new MutationObserver(sync).observe(group, { attributes: true, subtree: true, attributeFilter: ['aria-checked'] });
  }

  /* ---------- quantity ---------- */
  const step = () => Number(qtyInput.step) || 1;
  const minQ = () => Number(qtyInput.min) || 1;
  const maxQ = () => (qtyInput.max ? Number(qtyInput.max) : Infinity);
  const setQty = (n) => {
    qtyInput.value = String(Math.max(minQ(), Math.min(maxQ(), n)));
  };
  const minus = $('[data-lt-qty-minus]');
  const plus = $('[data-lt-qty-plus]');
  if (minus) minus.addEventListener('click', () => setQty((Number(qtyInput.value) || minQ()) - step()));
  if (plus) plus.addEventListener('click', () => setQty((Number(qtyInput.value) || minQ()) + step()));
  if (qtyInput) qtyInput.addEventListener('change', () => setQty(Number(qtyInput.value) || minQ()));

  /* ---------- add to cart through Horizon's cart events so the drawer and header bubble update ---------- */
  let busy = false;
  const say = (msg, isError) => {
    if (errorEl) {
      errorEl.hidden = !isError;
      errorEl.textContent = isError ? msg : '';
    }
    if (statusEl) statusEl.textContent = isError ? '' : msg;
    if (!isError && msg) window.setTimeout(() => (statusEl.textContent = ''), 4000);
  };

  const addToCart = async () => {
    if (busy || !form.checkValidity()) {
      form.reportValidity();
      return;
    }
    busy = true;
    [atc, stickyAtc].forEach((b) => b && (b.disabled = true));
    say('', false);
    let events = null;
    try {
      events = await import('@shopify/events');
    } catch (e) {
      events = null;
    }
    const routes = (window.Theme && window.Theme.routes) || {};
    const addUrl = routes.cart_add_url || '/cart/add.js';
    const cartUrl = (routes.cart_url || '/cart') + '.js';
    const fd = new FormData(form);
    // fresh cart markup for the drawer comes back with the add (applied by lt-cart.js)
    fd.append('sections', 'cart-drawer-section');
    const qty = Number(fd.get('quantity')) || 1;
    const deferred = events && events.CartLinesUpdateEvent ? events.CartLinesUpdateEvent.createPromise() : null;
    if (deferred) {
      form.dispatchEvent(
        new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(fd.get('id')), quantity: qty }],
          promise: deferred.promise
        })
      );
    }
    const finish = (detail) => {
      busy = false;
      applyVariant(current(), false);
      return detail;
    };
    let added = false;
    try {
      const res = await fetch(addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
      const json = await res.json();
      const cart = await (await fetch(cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
      if (json.status) {
        say(json.description || json.message || 'This item could not be added. Please try again.', true);
        if (deferred) deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'lt-product', sourceId: 'lt-pdp', itemCount: qty, productId: root.dataset.productId } });
      } else {
        added = true;
        say('Added to cart', false);
        if (deferred) deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'lt-product', sourceId: 'lt-pdp', itemCount: qty, productId: root.dataset.productId, sections: json.sections, didError: false } });
      }
    } catch (err) {
      if (deferred) deferred.reject(err);
      say('Something went wrong. Please check your connection and try again.', true);
    }
    // Confirmation for the shopper: open Horizon's cart drawer once the cart has updated.
    if (added) {
      if (deferred) await deferred.promise.catch(() => {});
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        // The drawer opens only here, after a successful add (Horizon's auto-open setting is off).
        await new Promise((r) => window.setTimeout(r, 350));
        const dlg = drawer.querySelector('dialog');
        if (!(dlg && dlg.open)) drawer.open();
      } else {
        window.location.assign(routes.cart_url || '/cart');
      }
    }
    finish();
  };

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    addToCart();
  });
  if (stickyAtc) stickyAtc.addEventListener('click', () => form.requestSubmit());

  /* ---------- sticky bar: shows once the main Add to cart has scrolled above the viewport; hidden while the cart drawer is open ---------- */
  const bar = $('[data-lt-sticky]');
  if (bar && atc) {
    const phone = window.matchMedia('(max-width: 1023px)');
    const applies = () => phone.matches;
    let pastAtc = false;
    const cartDialog = () => {
      const d = document.getElementById('cart-drawer');
      return d ? d.querySelector('dialog') : null;
    };
    // Read the drawer's real state (the dialog's open property) every time; a drawer that is closed on load is closed.
    const isDrawerOpen = () => {
      const dlg = cartDialog();
      return !!(dlg && dlg.open);
    };
    const render = () => {
      const on = applies() && pastAtc && !isDrawerOpen();
      bar.classList.toggle('lt-sticky--on', applies());
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', String(!on));
      // keep the hidden bar out of the tab order
      bar.querySelectorAll('button').forEach((b) => (b.tabIndex = on ? 0 : -1));
    };
    const syncBody = () => document.body.classList.toggle('lt-has-sticky', applies());
    let io = null;
    const headerH = () => {
      const h = document.querySelector('.lt-header');
      return h ? Math.round(h.getBoundingClientRect().height) : 0;
    };
    const observe = () => {
      if (io) io.disconnect();
      // A button hidden under the sticky header must count as out of view, so the observer's top edge is the header's bottom edge.
      // root: null observes against the viewport and works with nested scrollers such as Horizon's .page-wrapper.
      io = new IntersectionObserver(
        (entries) => {
          // A batch can hold several entries (iOS Safari batches during momentum scrolling); the newest is last.
          const en = entries[entries.length - 1];
          const edge = en.rootBounds ? en.rootBounds.top : 0;
          pastAtc = !en.isIntersecting && en.boundingClientRect.top < edge;
          render();
        },
        { threshold: 0, rootMargin: `-${headerH()}px 0px 0px 0px` }
      );
      io.observe(atc);
    };
    if (!('IntersectionObserver' in window)) {
      pastAtc = true; // no observer support: keep the bar available rather than never showing it
    } else {
      observe();
      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(observe, 150);
      });
    }
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      // Re-evaluate whenever the dialog's open attribute changes; the value itself is read from dialog.open in render().
      new MutationObserver(render).observe(drawer, { attributes: true, attributeFilter: ['open'], subtree: true });
      ['theme-drawer:open', 'theme-drawer:close'].forEach((ev) => document.addEventListener(ev, () => window.setTimeout(render, 0)));
      drawer.addEventListener('close', render, true);
    }
    phone.addEventListener('change', () => {
      syncBody();
      render();
    });
    syncBody();
    render();
  }

  /* ---------- start ---------- */
  buildThumbs(current().media);
  show(0, false);
  mobile.addEventListener('change', () => show(active, false));
}
